import { c as _c } from "react/compiler-runtime";
import AppHeaderClient from './app-header-client';
import { buildTranslatedRoute, getAppLocale, getMenuItems } from '@/lib/utils.server';
const AppHeader = async t0 => {
  const $ = _c(8);
  const {
    hasToken
  } = t0;
  let cataloguesRoute;
  let menuItems;
  let photoGalleriesRoute;
  let productRoute;
  let productsRoute;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      backendLocale
    } = await getAppLocale();
    menuItems = await getMenuItems(backendLocale);
    productsRoute = await buildTranslatedRoute(backendLocale, "products");
    productRoute = await buildTranslatedRoute(backendLocale, "product");
    photoGalleriesRoute = await buildTranslatedRoute(backendLocale, "corporate/photo-galleries");
    cataloguesRoute = await buildTranslatedRoute(backendLocale, "corporate/catalogues");
    t1 = await buildTranslatedRoute(backendLocale, "order-track");
    $[0] = cataloguesRoute;
    $[1] = menuItems;
    $[2] = photoGalleriesRoute;
    $[3] = productRoute;
    $[4] = productsRoute;
    $[5] = t1;
  } else {
    cataloguesRoute = $[0];
    menuItems = $[1];
    photoGalleriesRoute = $[2];
    productRoute = $[3];
    productsRoute = $[4];
    t1 = $[5];
  }
  const orderTrackRoute = t1;
  let t2;
  if ($[6] !== hasToken) {
    t2 = <AppHeaderClient menuItems={menuItems} productsRoute={productsRoute} productRoute={productRoute} photoGalleriesRoute={photoGalleriesRoute} cataloguesRoute={cataloguesRoute} orderTrackRoute={orderTrackRoute} hasToken={hasToken} />;
    $[6] = hasToken;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default AppHeader;